<template>
  <div class="editar_perfil">
    <div class="descTable">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h2 style="color:white; box-shadow: 1px 1px 8px black;">
            <svg
              style="width:24px;height:24px;margin-left: 87px;margin-bottom: -4px;"
              viewBox="0 0 24 24"
            >
              <path
                fill="#fff"
                d="M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"
              ></path>
            </svg>
            Minha conta
            <span v-if="this.cadastro">- Concluindo cadastro</span>
            <span v-else>- Editar informações do perfil</span>
          </h2>
        </v-flex>
      </v-layout>
    </div>
    <div
      v-if="this.cadastro"
      style="position: relative;left: 50%;transform: translateX(-19%);margin-bottom: 19px;"
    >
      <img
        style="width: 40%;cursor:pointer"
        @click="$router.push('/')"
        title="Motor Fiscal"
        id="logo-image"
        src="@/assets/images/logo_transparente/Logotipo_5.png"
        alt="Logo da Empresa(Motor Fiscal)"
      >
    </div>
    <v-tabs
      slider-color="indigo darken-4"
      left
      v-model="currentItem"
      id="containerTab"
      class="tabPerfil"
      color="grey lighten-5"
    >
    
      <v-tab
        id="tabOption"
        v-for="(item,i) in tabs"
        :key="i"
        :class="[i == currentItem ? 'active' : '']"
        v-if="cadastro && i != 2 || cadastro != true"
      >{{ item.title }}</v-tab>
      
      <v-tab-item @keydown.enter="salvarDados()">  
        <v-card flat v-show="this.currentItem == 0">
          <v-card-text>
            <div class="cardPerfil">
              <div class="cardPerfil-title">Avatar para o seu perfil na Plataforma</div>
              <div class="cardPerfil-body">
                <div class="cardPerfil-img">
                  <!-- <img
                    v-if="this.cadastro"
                    id="userLogo"
                    :src=" this.conta.gravatarProfile && this.conta.gravatarProfile.thumbnailUrl ?  this.conta.gravatarProfile.thumbnailUrl + '?s=200' : '@/../static/img/avatar.png'"
                    alt="Logo da Empresa(Motor Fiscal)"
                  >-->
                  <img
                    v-if="avatarProfile != ''"
                    id="userLogo_ePerfil"
                    :src="avatarProfile"
                    alt="Avatar de Perfil(Motor Fiscal)"
                  >
                  <img
                    v-else
                    id="userLogo_ePerfil"
                    src="@/assets/images/avatar.png"
                    alt="Avatar de Perfil(Motor Fiscal)"
                  >
                </div>
                <div class="cardPerfil-inputFile d-inline-block">
                  <inputFile
                    :component="'imagem'"
                    :prevIcon="'image'"
                    :text="'Selecione uma imagem'"
                    :resetInput="resetInputImage"
                    @getFile="getFile($event)"
                    @emitResetInput="emitResetInput($event)"
                  ></inputFile>
                </div>
                <div class="getImageGravatar">
                  <div class="ou">Ou</div>
                  <v-checkbox
                    v-model="usarGravatar"
                    color="teal"
                    hide-details
                    @change="getGravatar()"
                  >
                    <template slot="label">
                      <v-tooltip bottom close-delay="1500">
                        <span slot="activator" style="font-size: 13px;margin-right: 10px;">
                          Usar imagem do
                          <span class="undeline_gravatar">Gravatar</span> ?
                          <v-icon
                            style="position: absolute;top: -4px;right: 0;font-size: 11px!important;"
                            color="primary"
                          >help</v-icon>
                        </span>
                        <span>
                          <span class="undeline_gravatar">Gravatar</span> é uma plataforma que agiliza o
                          <br>processo que envolvem imagens, não conhece ?
                          <br>
                          <a
                            href="https://br.gravatar.com/"
                            target="_blank"
                          >https://br.gravatar.com/</a>
                        </span>
                      </v-tooltip>
                      <v-progress-circular
                        v-if="buscaGravatar"
                        :indeterminate="buscaGravatar"
                        :value="0"
                        size="24"
                        class="ml-2"
                      ></v-progress-circular>
                      <v-icon v-if="!buscaGravatar && gravatarSuccess" medium color="green">done</v-icon>
                      <v-tooltip v-else-if="!buscaGravatar && gravatarError" bottom>
                        <v-icon slot="activator" medium size color="red">error</v-icon>
                        <span>{{msgErrorGravatar}}</span>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                </div>
              </div>
            </div>

            <FormUsuario
              :conta="this.conta"
              :displayFlex="'xs12 sm12 md12'"
              :edit="true"
              :getDadosForm="getDadosForm"
              @emitDadosForm="emitDadosForm($event)"
            ></FormUsuario>

            <v-container grid-list-md text-xs-center>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-btn
                    block
                    outline
                    color="red"
                    @click.native="cadastro == true ? $router.push('/') : $router.push('/DashBoard')"
                  >Cancelar</v-btn>
                </v-flex>
                <v-flex xs6>
                  <v-btn
                    block
                    color="success"
                    @click.native="salvarDados()"
                  >{{this.cadastro == true ? 'Concluir Cadastro' : 'Salvar'}}</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item @keydown.enter="salvarDados()">
        <v-card flat v-show="this.currentItem == 1">
          <v-card-text>
            <v-form ref="formPass" v-if="this.cadastro != true" v-model="validPass" lazy-validation>
              <v-text-field
                color="teal"
                label="Senha atual:"
                :append-icon="show1 ? 'visibility_off' : 'visibility'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                :rules="passwordRules"
                prepend-icon="lock"
                @input="passwordRules.length > 1 ? passwordRules.pop() : ''"
                validate-on-blur
                class="input-required"
                v-model="pass1"
                ref="pass1"
                clearable
                required
              ></v-text-field>

              <v-text-field
                color="teal"
                label="Senha:"
                :append-icon="show2 ? 'visibility_off' : 'visibility'"
                :type="show2 ? 'text' : 'password'"
                @click:append="show2 = !show2"
                :rules="this.pass1 != '' ? passwordRules : undefined"
                v-model="pass2"
                validate-on-blur
                prepend-icon="lock"
                id="usuario-email"
                class="input-required"
                ref="pass2"
                @input="passwordRules.length > 1 ? passwordRules.pop() : ''"
                clearable
                required
              ></v-text-field>

              <v-text-field
                color="teal"
                :rules="this.pass1 != '' ? passwordRules : undefined"
                v-model="pass3"
                label="Confirmação da senha:"
                :append-icon="show3 ? 'visibility_off' : 'visibility'"
                :type="show3 ? 'text' : 'password'"
                @click:append="show3 = !show3"
                prepend-icon="lock"
                ref="pass3"
                validate-on-blur
                id="usuario-password"
                class="input-required"
                @input="passwordRules.length > 1 ? passwordRules.pop() : ''"
                clearable
                required
              ></v-text-field>
            </v-form>

            <v-form ref="formPass" v-else v-model="validPass" lazy-validation>
              <v-text-field
                color="teal"
                label="Senha:"
                :append-icon="show2 ? 'visibility_off' : 'visibility'"
                :type="show2 ? 'text' : 'password'"
                validate-on-blur
                @click:append="show2 = !show2"
                v-model="pass2"
                prepend-icon="lock"
                id="usuario-email"
                ref="pass2"
                class="input-required"
                @input="passwordRules.length > 1 ? passwordRules.pop() : ''"
                :rules="passwordRules"
                clearable
                required
              ></v-text-field>

              <v-text-field
                color="teal"
                v-model="pass3"
                label="Confirmação da senha:"
                validate-on-blur
                :append-icon="show3 ? 'visibility_off' : 'visibility'"
                :type="show3 ? 'text' : 'password'"
                @click:append="show3 = !show3"
                @input="passwordRules.length > 1 ? passwordRules.pop() : ''"
                :rules="passwordRules"
                ref="pass3"
                prepend-icon="lock"
                id="usuario-password"
                class="input-required"
                clearable
                required
              ></v-text-field>
            </v-form>

            <v-container grid-list-md text-xs-center>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-btn
                    block
                    outline
                    color="red"
                    @click.native="cadastro == true ? $router.push('/') : $router.push('/DashBoard')"
                  >Cancelar</v-btn>
                </v-flex>
                <v-flex xs6>
                  <v-btn
                    block
                    color="success"
                    @click.native="salvarDados()"
                  >{{this.cadastro == true ? 'Concluir Cadastro' : 'Salvar'}}</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item @keydown.enter="salvarDados()" v-if="this.cadastro != true">
        <v-card flat v-show="this.currentItem == 2">
          <v-card-text>
            <v-container v-if="empresa && empresa._id" fluid>
              <article class="panel_notifi">
                <small class="title_emp_notifi">Notificações de: {{empresa.razao}}</small>
                <article class="body_notifi">
                  <v-layout row wrap align-center justify-center fill-height class="dark--text">
                    <v-flex xs12>
                      <div>
                        <h3 class="text-xs-center">Envio das notificações:</h3>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-switch
                        :value="empresa._id"
                        label="Central de notificações do motor fiscal"
                        color="success"
                        input-value="true"
                        @change="resetOpcaoNotificacoes('geral')"
                        v-model="notificacoes.geral.ativo"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs6>
                      <v-switch
                        :value="empresa._id"
                        label="Envio por E-mail"
                        color="success"
                        input-value="true"
                        @change="resetOpcaoNotificacoes('email')"
                        v-model="notificacoes.email.ativo"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                  <article class="notifi_email">
                    <v-layout row wrap align-center justify-center fill-height class="dark--text">
                      <v-fade-transition leave-absolute>
                        <v-flex
                          xs12
                          v-show="this.notificacoes.email.ativo.indexOf(empresa._id) != -1"
                          class
                        >
                          <h3 class="text-xs-center">Opções das notificações por e-mail:</h3>
                        </v-flex>
                      </v-fade-transition>
                    </v-layout>
                    <v-fade-transition leave-absolute>
                      <v-layout
                        row
                        wrap
                        v-if="this.notificacoes.email.ativo.indexOf(empresa._id) != -1"
                      >
                        <!-- <v-flex xs4>
                          <v-switch
                            :value="empresa._id"
                            label="Resumo diário"
                            color="success"
                            v-model="notificacoes.email.resumoDiario"
                          ></v-switch>
                        </v-flex>-->
                        <!-- <v-flex xs4>
                          <v-switch
                            :value="empresa._id"
                            label="Resumo semanal"
                            color="success"
                            v-model="notificacoes.email.resumoSemanal"
                          ></v-switch>
                        </v-flex>-->
                        <v-flex xs4>
                          <v-switch
                            :value="empresa._id"
                            label="Novo Fornecedor"
                            color="success"
                            v-model="notificacoes.email.novoFornecedor"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs4>
                          <v-switch
                            :value="empresa._id"
                            label="Novo Cliente"
                            color="success"
                            v-model="notificacoes.email.novoCliente"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs4>
                          <v-switch
                            :value="empresa._id"
                            label="Notas Canceladas"
                            color="success"
                            v-model="notificacoes.email.notaCancelada"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs4>
                          <v-switch
                            :value="empresa._id"
                            label="Nova NF-e"
                            color="success"
                            v-model="notificacoes.email.nvNotaNfe"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs4>
                          <v-switch
                            :value="empresa._id"
                            label="Nova CT-e"
                            color="success"
                            v-model="notificacoes.email.nvNotaCte"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs4>
                          <v-switch
                            :value="empresa._id"
                            label="Nova NFS-e"
                            color="success"
                            v-model="notificacoes.email.nvNotaNfse"
                          ></v-switch>
                        </v-flex>
                        <!-- <v-flex xs4>
                          <v-switch
                            :value="empresa._id"
                            label="Vencimento da Nota Fiscal - eletrônica (NF-e)"
                            color="success"
                            v-model="notificacoes.email.vencimentoNF"
                          ></v-switch>
                        </v-flex>-->
                      </v-layout>
                    </v-fade-transition>
                  </article>
                  <article class="notifi_geral">
                    <v-layout row wrap align-center justify-center fill-height class="dark--text">
                      <v-fade-transition leave-absolute>
                        <v-flex
                          xs12
                          v-show="this.notificacoes.geral.ativo.indexOf(empresa._id) != -1"
                          class
                        >
                          <h3 class="text-xs-center">Opções das notificações Motor Fiscal:</h3>
                        </v-flex>
                      </v-fade-transition>
                    </v-layout>
                    <v-fade-transition leave-absolute>
                      <v-layout
                        row
                        wrap
                        v-if="this.notificacoes.geral.ativo.indexOf(empresa._id) != -1"
                      >
                        <v-flex xs4>
                          <v-switch
                            :value="empresa._id"
                            label="Notas Canceladas"
                            color="success"
                            v-model="notificacoes.geral.notaCancelada"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs4>
                          <v-switch
                            :value="empresa._id"
                            label="Última consulta"
                            color="success"
                            v-model="notificacoes.geral.ultConsulta"
                          ></v-switch>
                        </v-flex>
                      </v-layout>
                    </v-fade-transition>
                  </article>
                  <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-btn
                          block
                          outline
                          color="red"
                          @click.native="cadastro == true ? $router.push('/') : $router.push('/DashBoard')"
                        >Cancelar</v-btn>
                      </v-flex>
                      <v-flex xs6>
                        <v-btn block color="success" @click.native="salvarDados()">Salvar</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </article>
              </article>
            </v-container>
            <v-container v-else>Necessário selecionar alguma empresa.</v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <!-- <v-card-text style="position: absolute;top: 12em;width: 65.4%;margin: 0 auto;left: 17.3%;"><v-progress-linear v-if="enviandoDados" color="teal" height="20" indeterminate style="z-index: 3;"></v-progress-linear></v-card-text> -->
  </div>
</template>

<script>
import FormUsuario from "@/components/conta/usuario/formUsuario/FormUsuario.vue";
import UsuarioService from "@/domain/conta/usuario/UsuarioService.js";
import inputFile from "@/components/shared/inputFile/InputFile.vue";
import GravatarService from "@/domain/gravatar/GravatarService.js";
export default {
  components: {
    inputFile: inputFile,
    FormUsuario: FormUsuario
  },
  props: ["alert", "conta", "cadastro", "empresa"],
  data() {
    return {
      getDadosForm: false,
      notificacoes: {
        geral: {
          ativo: [],
          notaCancelada: [],
          ultConsulta: []
        },
        email: {
          ativo: [],
          resumoDiario: [],
          resumoSemanal: [],
          novoFornecedor: [],
          novoCliente: [],
          vencimentoNF: [],
          notaCancelada: [],
          nvNotaNfe: [],
          nvNotaCte: [],
          nvNotaNfse: []
        }
      },
      validPass: true,
      show1: false,
      show2: false,
      show3: false,
      avatarProfile: "",
      pass1: "",
      pass2: "",
      pass3: "",
      enviandoDados: false,
      buscaGravatar: false,
      gravatarSuccess: false,
      gravatarError: false,
      usarGravatar: false,
      resetInputImage: false,
      msgErrorGravatar: "",
      passwordRules: [
        v => !!v || "Campo é obrigatório",
      ],
      route: this.$router.history.current.path,
      currentItem: "",
      img: null,
      tabs: [
        {
          title: "Dados Pessoais"
        },
        {
          title: "Minha senha"
        },
        {
          title: "Notificações"
        }
      ]
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      if (this.cadastro) {
        this.currentItem = 1;
      }
      if (this.cadastro != true) {
        if (this.conta.imagem) {
          this.resetGravatar();
          let dataImg = `data:image/jpg;base64,${this.bufferToBase64(
            this.conta.imagem.data
          )}`;
          this.avatarProfile = `${dataImg}`;
        } else if (this.conta != undefined && this.conta.gravatarProfile != undefined && !this.conta.gravatarProfile.hasOwnProperty('body')) {
          this.usarGravatar = true;
          this.avatarProfile =
            this.conta.gravatarProfile.thumbnailUrl + "?s=200";
        }
      }
      // if (this.cadastro != true && this.$session.exists()) {
      //   if (this.$session.get("jwt").gravatarProfile != undefined) {
      //     this.avatarProfile =
      //       this.$session.get("jwt").gravatarProfile.thumbnailUrl + "?s=200";
      //   }
      // }
      // if (this.cadastro && this.conta.gravatarProfile != undefined) {
      //   this.avatarProfile = this.conta.gravatarProfile + "?s=200";
      // }
    });
  },
  watch: {
    empresa: function(newV, oldV) {
      if (newV._id != oldV._id) {
        this.getUserById();
      }
    },
    currentItem: function(newV, oldV) {
      if (this.empresa) {
        this.getUserById();
      }
    }
  },
  updated: function() {},
  computed: {
    resetNotificacoesEmail: function() {
      this.notificacoes.email.resumoDiario = [];
      this.notificacoes.email.resumoSemanal = [];
      this.notificacoes.email.novoFornecedor = [];
      this.notificacoes.email.novoCliente = [];
      this.notificacoes.email.vencimentoNF = [];
      this.notificacoes.email.notaCancelada = [];
      this.notificacoes.email.nvNotaNfe = [];
      this.notificacoes.email.nvNotaCte = [];
      this.notificacoes.email.nvNotaNfse = [];
    }
  },
  methods: {
    activeGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    },
    emitResetInput($event) {
      this.resetInputImage = $event;
    },
    bufferToBase64(buf) {
      var binstr = Array.prototype.map
        .call(buf, function(ch) {
          return String.fromCharCode(ch);
        })
        .join("");
      return btoa(binstr);
    },
    getGravatar: async function() {
      if (this.usarGravatar) {
        this.resetInputImage = true;
        this.buscaGravatar = true;
        if (this.conta.email) {
          this.service = new GravatarService(this.$http);
          await this.service.getGravatar(this.conta.email).then(resp => {
            this.buscaGravatar = false;
            if (resp.ok == false) {
              this.gravatarSuccess = false;
              this.gravatarError = true;
              this.usarGravatar = false;
              this.msgErrorGravatar = "Usuário não encontrado no Gravatar.";
            } else {
              this.gravatarSuccess = true;
              this.gravatarError = false;
              this.conta["gravatarProfile"] = resp;
              var output = document.querySelectorAll("#userLogo_ePerfil");
              output.forEach(element => {
                element.src = `${resp.thumbnailUrl}?size=200`;
              });
              this.img = undefined;
            }
          });
        }
      } else {
        this.resetGravatar();
      }
    },
    getUserById: function() {
      if (this.conta) {
        if (this.conta.id_usuario) {
          this.service = new UsuarioService(this.$http);
          this.service.getUsuarioId(this.conta.id_usuario).then(resp => {
            this.notificacoes.email = resp.body.notificacoesEmail;
            this.notificacoes.geral = resp.body.notificacoesGeral;
          });
        }
      }
    },
    resetGravatar() {
      this.usarGravatar = false;
      this.buscaGravatar = false;
      this.gravatarSuccess = false;
      this.gravatarError = false;
    },
    getFile(file) {
      this.resetGravatar();
      this.img = file;
      if (file) {
        var output = document.querySelectorAll("#userLogo_ePerfil");
        output.forEach(element => {
          element.src = URL.createObjectURL(file[0]);
        });
        this.img = file[0];
      }
    },
    verifSenha: async function() {
      let conta = { email: this.conta.email, password: this.pass1 };
      let body = JSON.stringify(conta);
      return await this.$http.post("usuarios/authenticate", body).then(
        success => {
          return true;
        },
        failed => {
          this.passwordRules.push(function senhaInvalida(value) {
            return "Senha invalida";
          });
          return false;
        }
      );
    },
    async emitDadosForm(value) {
      let envDados = false;
      if (value != false) {
        if (this.img != null) {
          value["img"] = this.img;
        }
        if (this.pass1 != "" || this.cadastro) {
          
          if (this.passwordRules.length > 2) {
            this.passwordRules.pop();
          }
          
          if (!this.cadastro) {
            await this.verifSenha();
            if (!this.$refs.pass1.validate()) {
              this.currentItem = 1;
              this.getDadosForm = false;
              return;
            }
          }
          if (this.pass2 != this.pass3) {
            if (this.passwordRules.length > 2) {
              this.passwordRules.pop();
            }
            this.currentItem = 1;
            this.passwordRules.push(function diferentes(value) {
              return "Senhas não coincídem";
            });
            this.$refs.pass2.validate();
            this.$refs.pass3.validate();
          } else if (this.$refs.formPass.validate()) {
            value["password"] = this.pass2;
            envDados = true;
          }else{
            this.currentItem = 1;
          }
        } else {
          envDados = true;
        }
      } else {
        this.currentItem = 0;
      }
      this.getDadosForm = false;
      const data = new FormData();
      if (this.empresa) {
          if (this.empresa._id) {
            value["notificacoesGeral"] = JSON.stringify(this.notificacoes.geral)
            value["notificacoesEmail"] = JSON.stringify(this.notificacoes.email)
          }
        }
      //removendo os atributos que não vão ser editados.
      for (let prop in value) {
        if (value[prop] == null || value[prop] == undefined) {
          delete value[prop];
        } else {
          data.append(prop, value[prop]);
        }
      }
      if (envDados) {
        if (this.cadastro) {
          value["preCadastro"] = "";
          data.append("preCadastro", value["preCadastro"]);
        }
        
        let idUsuario = this.conta.id_usuario;
        this.enviandoDados = true;
        this.service = new UsuarioService(this.$http);
        this.activeGlobalLoader();
        document.querySelector('html').scrollTo(0,0)
        this.service
          .editar(data, idUsuario)
          .then(resp => {
            this.desactiveGlobalLoader();
            this.alert.snackDanger();
            this.enviandoDados = false;
            this.alert.snack.text = "Ocorreu algum erro";
            if (resp.ok) {
              this.conta.nome = data.get('nome');
              this.alert.snackSuccess();
              this.alert.snack.text = "Informações alteradas.";
              if (this.cadastro) {
                this.alert.snack.text =
                  "Cadastro concluido, agora poderá acessar o Motor Fiscal.";

                let conta = {};
                conta["email"] = value.email;
                conta["password"] = value.password;
                let body = JSON.stringify(conta);
                this.$http.post("usuarios/authenticate", body).then(
                  success => {
                    this.redirectUser(success);
                  },
                  failed => {
                    let router = this.$router;
                    setTimeout(function() {
                      router.push("/login");
                    }, 4000);
                  }
                );
                // this.$router.push('/login');
              } else {
                if (this.img || this.usarGravatar) {
                  if (resp.body.imgBuffer) {
                    let output = document.querySelectorAll("#userLogo");
                    output.forEach(element => {
                      element.src = URL.createObjectURL(this.img);
                    });
                    this.img = resp.body.imgBuffer;
                  } else {
                    let output = document.querySelectorAll("#userLogo");
                    output.forEach(element => {
                      element.src = `${
                        this.conta["gravatarProfile"].thumbnailUrl
                      }?size=200`;
                    });
                  }
                  try{
                    this.conta.imagem = this.img;
                    let auxConta = this.$session.get("jwt");
                    auxConta["img"] = this.img;
                    this.$session.set("jwt", auxConta);
                    this.img = undefined;
                  }
                  catch(err){
                    console.log(`Não foi possivel setar imagem ${err}`)
                  }
                }
              }
            }
            this.alert.snack.show = true;
          })
          .then(() => {
            if (this.conta && !this.cadastro) {
              this.conta.getNotificacoes = true;
            }
          });
      }
    },

    resetOpcaoNotificacoes: function(tipo) {
      switch (tipo) {
        case "email":
          this.rmvItemArray(
            this.notificacoes.email.resumoDiario.indexOf(this.empresa._id),
            this.notificacoes.email.resumoDiario
          );

          this.rmvItemArray(
            this.notificacoes.email.resumoSemanal.indexOf(this.empresa._id),
            this.notificacoes.email.resumoSemanal
          );

          this.rmvItemArray(
            this.notificacoes.email.novoFornecedor.indexOf(this.empresa._id),
            this.notificacoes.email.novoFornecedor
          );

          this.rmvItemArray(
            this.notificacoes.email.novoCliente.indexOf(this.empresa._id),
            this.notificacoes.email.novoCliente
          );

          this.rmvItemArray(
            this.notificacoes.email.vencimentoNF.indexOf(this.empresa._id),
            this.notificacoes.email.vencimentoNF
          );

          this.rmvItemArray(
            this.notificacoes.email.notaCancelada.indexOf(this.empresa._id),
            this.notificacoes.email.notaCancelada
          );

          this.rmvItemArray(
            this.notificacoes.email.nvNotaNfe.indexOf(this.empresa._id),
            this.notificacoes.email.nvNotaNfe
          );

          this.rmvItemArray(
            this.notificacoes.email.nvNotaCte.indexOf(this.empresa._id),
            this.notificacoes.email.nvNotaCte
          );

          this.rmvItemArray(
            this.notificacoes.email.nvNotaNfse.indexOf(this.empresa._id),
            this.notificacoes.email.nvNotaNfse
          );
          break;
        case "geral":
          this.rmvItemArray(
            this.notificacoes.geral.notaCancelada.indexOf(this.empresa._id),
            this.notificacoes.geral.notaCancelada
          );
          this.rmvItemArray(
            this.notificacoes.geral.ultConsulta.indexOf(this.empresa._id),
            this.notificacoes.geral.ultConsulta
          );
          break;
      }
    },
    rmvItemArray(pos, array) {
      if (pos != -1) {
        array.splice(pos, 1);
      }
    },
    salvarDados() {
      this.getDadosForm = true;
      // alert("Implementar Lógica");
    },
    redirectUser: async function(success) {
      let router = this.$router;
      let conta = success.body;
      this.$session.start();
      this.service = new GravatarService(this.$http);
      await this.service
        .getGravatar(success.body.email)
        .then(
          success => {
            if(success){
              if(success.hasOwnProperty('thumbnailUrl')){
                conta["gravatarProfile"] = success;
              }
            }
          }
        )
        .then(x => {
          this.$session.set("jwt", conta);
          setTimeout(function() {
            router.push("/DashBoard");
          }, 4000);
        });
      
    }
  },

  beforeMount: function() {
    this.$nextTick(function() {});
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  text-decoration: none;
  color: #42b983;
}
.iconCloud {
  transform: rotate(180deg);
}
#panelEmpresa {
  padding: 30px 0;
  background: #e3f2fd;
}
#panelEmpresa h1 {
  font-family: "Quicksand", sans-serif;
}

#containerTab div.v-tabs__container {
  margin-left: 35px !important;
}
.v-tabs__container {
  background-color: #fafafa !important;
}
.v-tabs__bar {
  padding-top: 35px !important;
}
.v-card__text {
  padding-top: 0 !important;
}
#tabOption.active {
  background-color: white;
}
#infoConsulta {
  text-align: center;
  position: absolute;
  right: 2%;
  border: 2px solid #cbcbcb;
  padding: 0 1.6%;
  height: 44px;
  border-radius: 6px;
}
/* .getImageGravatar::before{
  content: '';
  width: 10px;
  height: 10px;
  position: absolute;
} */
.getImageGravatar {
}
.ou:before {
  content: "";
  position: absolute;
  width: 45%;
  left: 0;
  top: 11px;
  height: 2px;
  background-color: #009688;
}
.ou {
  position: relative;
  text-align: center;
}
.ou:after {
  content: "";
  position: absolute;
  width: 42.5%;
  right: 13px;
  top: 11px;
  height: 2px;
  background-color: #009688;
}

#infoConsulta small {
  font-weight: bold;
  font-size: 66%;
}
#infoConsulta div {
  margin-top: -6px;
}
#infoConsulta i {
  font-size: 16px;
}
#infoConsulta span {
  font-size: 86%;
}
div#infoConsulta.cte {
  top: 9.9%;
  background-color: white;
}
.descTable {
  background-color: rgb(0, 150, 136) !important;
  margin: 0 0 39px 0px;
}
.descTable.cte {
  margin: 0 0 50px 0px;
}
.cardPerfil {
  margin-top: 39px;
}
.cardPerfil-title {
  background-color: lightgrey;
  padding: 15px;
  border-radius: 11px 11px 0 0;
  font-weight: 600;
  color: #5d5d5d;
}
.cardPerfil-img {
  width: 15%;
  display: inline-block;
  text-align: center;
}
.cardPerfil-img img {
  border-radius: 50%;
  width: 72px;
  height: 72px;
  text-align: center;
}

.cardPerfil-body {
  background-color: white;
  padding: 20px 0px 20px 15px;
}
.title_emp_notifi {
  color: #4d627b;
  opacity: 0.75;
  text-overflow: ellipsis !important;
  white-space: nowrap;
  width: 10px;
  font-size: 14px;
  overflow: hidden;
}
.body_notifi {
  padding: 13px;
  background-color: white;
}
.undeline_gravatar::before {
  content: "";
  position: absolute;
  bottom: -2px;
  width: 105%;
  height: 1.5px;
  background-color: #3d8cd9;
}
.undeline_gravatar {
  position: relative;
}
</style> 



// WEBPACK FOOTER //
// src/pages/loggedArea/editarPerfil/EditarPerfil.vue